<template>
  <PageContainer type="bg2">
    <div class="pay-success">
      <img :src="PaymentImage">
      <p class="pay-success__text">付款成功</p>
      <p class="pay-success__text">可以透過訂單編號： {{ $route.query.orderId }}，來查詢訂單相關狀態</p>
      <el-button type="primary" round>
        <router-link :to="{name: 'Order'}">
          查看訂單狀態
        </router-link>
      </el-button>
    </div>
  </PageContainer>
</template>
<script>
import PageContainer from '@/components/PageContainer.vue'
import PaymentImage from '@/assets/img/payment.png'

export default {
  components: {
    PageContainer
  },
  data() {
    return {
      PaymentImage
    }
  }
}
</script>
<style lang="scss" scoped>
.pay-success {
  text-align: center;

  &__text {
    font-size: 24px;
    font-weight: 600;
    margin-top: 20px;
  }

  a:hover {
    color: #fff;
  }
}

::v-deep.el-button--primary {
  background-color: $mainPurple;
  border: 0;
  &:hover, &:focus {
    background-color: $mainPurple;
    opacity: 0.8;
  }
}

</style>
